import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SuccessCheckmark = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50013 13.4749L4.02513 9.99987L2.8418 11.1749L7.50013 15.8332L17.5001 5.8332L16.3251 4.6582L7.50013 13.4749Z"
      />
    </SvgIcon>
  );
};

export default SuccessCheckmark;
